// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/PretendardGOV-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/PretendardGOV-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/PretendardGOV-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/PretendardGOV-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* resetCss */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
#root {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: var(--gray-5);
  font-family: -apple-system, BlinkMacSystemFont, system-ui, Roboto,
    "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
}
* {
  box-sizing: border-box;
}
button {
  flex-shrink: 0;
  all: unset; /* 모든 기본 스타일 제거 */
  display: inline-block; /* 기본적으로 레이아웃에 필요한 스타일 */
  cursor: pointer; /* 클릭 가능한 상태 표시 */
}

/* 폰트 */
@font-face {
  font-family: "PretendardGOV-Bold";
  font-weight: 700 !important;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
@font-face {
  font-family: "PretendardGOV-SemiBold";
  font-weight: 600 !important;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
}
@font-face {
  font-family: "PretendardGOV-Medium";
  font-weight: 500 !important;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
}
@font-face {
  font-family: "PretendardGOV-Regular";
  font-weight: 400 !important;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
}

/* 색상 토큰 */
:root {
  --black: #000000;
  --white: #ffffff;
  --primary-5: #eff5ff;
  --primary-10: #d3e1fb;
  --primary-20: #a7c4f7;
  --primary-30: #7ca6f3;
  --primary-40: #5089ef;
  --primary-50: #246beb;
  --primary-60: #1d56bc;
  --gray-5: #f8f8f8;
  --gray-10: #f0f0f0;
  --gray-20: #e4e4e4;
  --gray-30: #d8d8d8;
  --gray-40: #c6c6c6;
  --gray-50: #8e8e8e;
  --gray-60: #717171;
  --gray-70: #555555;
  --gray-90: #1d1d1d;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,aAAa;AACb;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;AACA,gDAAgD;AAChD;;;;;;;;;;;EAWE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,YAAY;AACd;AACA;;;;EAIE,WAAW;EACX,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;EAC/B;;;cAGY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,UAAU,EAAE,iBAAiB;EAC7B,qBAAqB,EAAE,wBAAwB;EAC/C,eAAe,EAAE,iBAAiB;AACpC;;AAEA,OAAO;AACP;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,kBAAkB;EAClB,+DAA6D;AAC/D;AACA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,+DAAiE;AACnE;AACA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,+DAA+D;AACjE;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,+DAAgE;AAClE;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["/* resetCss */\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol,\nul {\n  list-style: none;\n}\nblockquote,\nq {\n  quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n#root {\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: var(--gray-5);\n  font-family: -apple-system, BlinkMacSystemFont, system-ui, Roboto,\n    \"Helvetica Neue\", \"Segoe UI\", \"Apple SD Gothic Neo\", \"Noto Sans KR\",\n    \"Malgun Gothic\", \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\",\n    sans-serif;\n}\n* {\n  box-sizing: border-box;\n}\nbutton {\n  flex-shrink: 0;\n  all: unset; /* 모든 기본 스타일 제거 */\n  display: inline-block; /* 기본적으로 레이아웃에 필요한 스타일 */\n  cursor: pointer; /* 클릭 가능한 상태 표시 */\n}\n\n/* 폰트 */\n@font-face {\n  font-family: \"PretendardGOV-Bold\";\n  font-weight: 700 !important;\n  font-style: normal;\n  src: url(\"./fonts/PretendardGOV-Bold.otf\") format(\"opentype\");\n}\n@font-face {\n  font-family: \"PretendardGOV-SemiBold\";\n  font-weight: 600 !important;\n  font-style: normal;\n  src: url(\"./fonts/PretendardGOV-SemiBold.otf\") format(\"opentype\");\n}\n@font-face {\n  font-family: \"PretendardGOV-Medium\";\n  font-weight: 500 !important;\n  font-style: normal;\n  src: url(\"./fonts/PretendardGOV-Medium.otf\") format(\"opentype\");\n}\n@font-face {\n  font-family: \"PretendardGOV-Regular\";\n  font-weight: 400 !important;\n  font-style: normal;\n  src: url(\"./fonts/PretendardGOV-Regular.otf\") format(\"opentype\");\n}\n\n/* 색상 토큰 */\n:root {\n  --black: #000000;\n  --white: #ffffff;\n  --primary-5: #eff5ff;\n  --primary-10: #d3e1fb;\n  --primary-20: #a7c4f7;\n  --primary-30: #7ca6f3;\n  --primary-40: #5089ef;\n  --primary-50: #246beb;\n  --primary-60: #1d56bc;\n  --gray-5: #f8f8f8;\n  --gray-10: #f0f0f0;\n  --gray-20: #e4e4e4;\n  --gray-30: #d8d8d8;\n  --gray-40: #c6c6c6;\n  --gray-50: #8e8e8e;\n  --gray-60: #717171;\n  --gray-70: #555555;\n  --gray-90: #1d1d1d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
